import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './style.scss';
import {Image} from "@mui/icons-material";

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();

    useEffect(() => {
        const savedLanguage = localStorage.getItem('i18nLanguage');

        if (savedLanguage) {
            i18n.changeLanguage(savedLanguage);
        } else {
            const browserLang = (navigator.language || navigator.userLanguage).split('-')[0]; // "en-US" -> "en"
            i18n.changeLanguage(browserLang);
            localStorage.setItem('i18nLanguage', browserLang);
        }
    }, []); // Pass an empty array to only run this effect on mount

    const changeLanguage = (event) => {
        const newLang = event.target.value;
        i18n.changeLanguage(newLang);
        localStorage.setItem('i18nLanguage', newLang);
    };

    return (
        <div className='container'>
            <select className='selector' onChange={changeLanguage} value={i18n.language}>
                <option value='en'>🇺🇸 English</option>
                <option value='ro'>🇷🇴 Romanian</option>
                <option value='es'>🇪🇸 Spanish</option>
                <option value='it'>🇮🇹 Italian</option>
                <option value='fr'>🇫🇷 French</option>
                <option value='de'>🇩🇪 German</option>
                <option value='zh'>🇨🇳 Chinese</option>
            </select>
        </div>
    );
};

export default LanguageSwitcher;
